import React, { useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const Star = ({ filled, onClick }) => (
  <button type="button" onClick={onClick}
    style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '26px', padding: '2px', lineHeight: 1, filter: filled ? 'none' : 'grayscale(100%) opacity(0.3)', transition: 'all 0.15s' }}>
    ⭐
  </button>
);

const StarRow = ({ label, value, onChange }) => (
  <div style={{ marginBottom: '14px' }}>
    <div style={{ fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>{label}</div>
    <div style={{ display: 'flex', gap: '4px' }}>
      {[1,2,3,4,5].map(s => <Star key={s} filled={s <= value} onClick={() => onChange(s)} />)}
      {value > 0 && <span style={{ fontSize: '12px', color: '#6b7280', alignSelf: 'center', marginLeft: '4px' }}>{value}/5</span>}
    </div>
  </div>
);

export default function PartnerSurveyModal({ onClose, onSubmit }) {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ nps_score: null, overall_rating: 0, platform_ease_rating: 0, support_rating: 0, referral_process_rating: 0, communication_rating: 0, what_working_well: '', what_could_improve: '', feature_requests: '' });
  const [submitting, setSubmitting] = useState(false);
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const token = localStorage.getItem('doorlypro_token');
      const res = await fetch(`${API}/api/doorlypro/survey/submit`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(form),
      });
      if (res.ok) { setStep(4); if (onSubmit) onSubmit(); }
    } catch (e) { console.error(e); }
    finally { setSubmitting(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ background: '#fff', borderRadius: '20px', padding: '32px', maxWidth: '500px', width: '100%', maxHeight: '90vh', overflowY: 'auto' }}>
        {step < 4 && <div style={{ display: 'flex', gap: '6px', marginBottom: '24px' }}>{[1,2,3].map(s => <div key={s} style={{ flex: 1, height: '4px', borderRadius: '2px', background: s <= step ? '#2563EB' : '#e5e7eb' }} />)}</div>}

        {step === 1 && (<>
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <div style={{ fontSize: '40px', marginBottom: '10px' }}>🤝</div>
            <h2 style={{ margin: '0 0 8px', fontSize: '20px', fontWeight: '800', color: '#111827' }}>How likely are you to recommend DoorlyPro?</h2>
            <p style={{ margin: 0, fontSize: '13px', color: '#6b7280' }}>0 = Not at all · 10 = Extremely likely</p>
          </div>
          <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '20px' }}>
            {[0,1,2,3,4,5,6,7,8,9,10].map(n => (
              <button key={n} onClick={() => set('nps_score', n)} type="button"
                style={{ width: '36px', height: '36px', borderRadius: '8px', border: `2px solid ${form.nps_score === n ? (n >= 9 ? '#166534' : n >= 7 ? '#92400e' : '#9f1239') : '#e5e7eb'}`, background: form.nps_score === n ? (n >= 9 ? '#f0fdf4' : n >= 7 ? '#fff7ed' : '#fff0f3') : '#fff', cursor: 'pointer', fontSize: '13px', fontWeight: form.nps_score === n ? '800' : '500', color: form.nps_score === n ? (n >= 9 ? '#166534' : n >= 7 ? '#92400e' : '#9f1239') : '#374151' }}>
                {n}
              </button>
            ))}
          </div>
          <button onClick={() => form.nps_score !== null && setStep(2)} disabled={form.nps_score === null}
            style={{ width: '100%', padding: '13px', background: form.nps_score !== null ? '#2563EB' : '#e5e7eb', color: '#fff', border: 'none', borderRadius: '12px', cursor: form.nps_score !== null ? 'pointer' : 'not-allowed', fontWeight: '700', fontSize: '15px' }}>
            Continue →
          </button>
          <button onClick={onClose} style={{ width: '100%', padding: '8px', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '13px', marginTop: '6px' }}>Maybe later</button>
        </>)}

        {step === 2 && (<>
          <h2 style={{ margin: '0 0 4px', fontSize: '18px', fontWeight: '800', color: '#111827' }}>Rate your experience</h2>
          <p style={{ margin: '0 0 20px', fontSize: '13px', color: '#6b7280' }}>How are we doing?</p>
          <StarRow label="Overall experience" value={form.overall_rating} onChange={v => set('overall_rating', v)} />
          <StarRow label="Ease of using the platform" value={form.platform_ease_rating} onChange={v => set('platform_ease_rating', v)} />
          <StarRow label="Referral submission process" value={form.referral_process_rating} onChange={v => set('referral_process_rating', v)} />
          <StarRow label="Communication from Doorly" value={form.communication_rating} onChange={v => set('communication_rating', v)} />
          <StarRow label="Support quality" value={form.support_rating} onChange={v => set('support_rating', v)} />
          <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
            <button onClick={() => setStep(1)} style={{ flex: 1, padding: '12px', background: '#f3f4f6', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', color: '#374151' }}>← Back</button>
            <button onClick={() => setStep(3)} style={{ flex: 2, padding: '12px', background: '#2563EB', color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '700' }}>Continue →</button>
          </div>
        </>)}

        {step === 3 && (<>
          <h2 style={{ margin: '0 0 4px', fontSize: '18px', fontWeight: '800', color: '#111827' }}>Tell us more</h2>
          <p style={{ margin: '0 0 16px', fontSize: '13px', color: '#6b7280' }}>Your feedback shapes how we improve DoorlyPro.</p>
          {[['what_working_well', "What's working well? 🌟", 'Share what you love...'], ['what_could_improve', 'What could be better? 💡', 'What would make it work better for you?'], ['feature_requests', 'Feature requests 🚀', 'Any features you wish we had?']].map(([k, label, ph]) => (
            <div key={k} style={{ marginBottom: '14px' }}>
              <label style={{ fontSize: '13px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '5px' }}>{label}</label>
              <textarea value={form[k]} onChange={e => set(k, e.target.value)} placeholder={ph} rows={2}
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: '10px', fontSize: '13px', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit' }} />
            </div>
          ))}
          <div style={{ display: 'flex', gap: '10px' }}>
            <button onClick={() => setStep(2)} style={{ flex: 1, padding: '12px', background: '#f3f4f6', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', color: '#374151' }}>← Back</button>
            <button onClick={handleSubmit} disabled={submitting}
              style={{ flex: 2, padding: '12px', background: '#acf44e', color: '#1a1a1a', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '800', fontSize: '15px' }}>
              {submitting ? 'Submitting...' : '✓ Submit Feedback'}
            </button>
          </div>
        </>)}

        {step === 4 && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: '56px', marginBottom: '14px' }}>🎉</div>
            <h2 style={{ margin: '0 0 10px', fontSize: '22px', fontWeight: '800', color: '#111827' }}>Thank you!</h2>
            <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '24px' }}>Your feedback helps us build a better DoorlyPro.</p>
            <button onClick={onClose} style={{ padding: '12px 32px', background: '#2563EB', color: '#fff', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: '700' }}>Close</button>
          </div>
        )}
      </div>
    </div>
  );
}
